import { type StyleConfigProps, type VisibilityElementProps } from '@blaze-runtime/engine-domain';
import { type ColumnInfo } from '@blaze-shared/api-contracts-domain';
import {
  type BorderRadiusValue,
  type CanvasElementPropertiesWithData,
  type ElementHorizontalAlignment,
  type ElementLabelPropsWithPositionAndWidth,
  type ElementLabelStyleProps,
  type FontOptions,
  type LabelIconAlignment,
  type PropertiesConfigInputColorModel,
  type PropertiesConfigInputSpacingAndAlignmentModel,
} from '@blaze-shared/elements-domain';
import { type ValueWithUnitOfMeasure } from '@blaze-shared/shared-util';

export const DEFAULT_UPLOAD_FILE_COLUMNS: ColumnInfo[] = [
  {
    name: 'filename',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
  },
  {
    name: 'mimetype',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
  },
  {
    name: 'type',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
  },
  {
    name: 'url',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
  },
  {
    name: 'size',
    columnType: 'Number',
    dataType: 'Number',
    isRequired: false,
    isProfilePicture: false,
  },
  {
    name: 'thumbnail',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
    isRequired: false,
  },
];

type PropsModel = CanvasElementPropertiesWithData & StyleConfigProps & VisibilityElementProps;

export type UploadFilePropsModel = PropsModel & {
  content: {
    button: {
      label: string;
      icon?: string;
      iconPosition?: LabelIconAlignment;
      readonly: boolean;
    };
    fileFormats: {
      enabled: boolean;
      csv: boolean;
      docs: boolean;
      image: boolean;
      video: boolean;
      audio: boolean;
    };
    options: {
      style?: 'drag-drop';
      multiple: boolean;
      saveAs: 'url' | 'base64';
      capture?: {
        enabled: boolean;
        format: 'image' | 'video';
        defaultCamera: 'user' | 'environment';
        saveAsMp4: boolean;
      };
    };
    title: ElementLabelPropsWithPositionAndWidth;
  };
  style: {
    fontSize: ValueWithUnitOfMeasure;
    fontFamily: string;
    lineHeight: ValueWithUnitOfMeasure;
    general: {
      title: PropertiesConfigInputColorModel;
      offset: PropertiesConfigInputSpacingAndAlignmentModel;
    };
    labelBlock: ElementLabelStyleProps;
    button: {
      outlineWidth: ValueWithUnitOfMeasure;
      radius: BorderRadiusValue;
    };
    dragDrop: {
      label: PropertiesConfigInputColorModel;
      action: PropertiesConfigInputColorModel;
      align: ElementHorizontalAlignment;
      font: FontOptions;
      fill: PropertiesConfigInputColorModel;
      outline: PropertiesConfigInputColorModel;
      outlineWidth: ValueWithUnitOfMeasure;
      radius: BorderRadiusValue;
    };
    upload: {
      // label:
      label: PropertiesConfigInputColorModel;
      align: ElementHorizontalAlignment;
      font: FontOptions;
      iconSize: ValueWithUnitOfMeasure;
      // button:
      fill: PropertiesConfigInputColorModel;
      outline: PropertiesConfigInputColorModel;
    };
    uploaded: {
      label: PropertiesConfigInputColorModel;
      fill: PropertiesConfigInputColorModel;
      outline: PropertiesConfigInputColorModel;
    };
  };
};
